import { ShopOutlined } from "@ant-design/icons";
import { Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import specstudioService from "../../../services/specstudioService";

// Shared across every select in the page so the catalog is fetched once
let printersRequest = null;
const loadPrinters = () => {
  printersRequest ||= specstudioService.getPrinters().catch((error) => {
    printersRequest = null;
    throw error;
  });
  return printersRequest;
};

export default function PrinterSelect({ value, onChange, ...props }) {
  const [printers, setPrinters] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    loadPrinters()
      .then((rows) => alive && setPrinters(rows || []))
      .catch(() => alive && setPrinters([]))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);
  // Inactive printers stay selectable only when already chosen
  const options = useMemo(
    () =>
      printers
        .filter((printer) => printer.isActive || printer.id === value)
        .map((printer) => ({
          value: printer.id,
          label: printer.isActive
            ? printer.name
            : `${printer.name} (ngừng hoạt động)`,
          code: printer.code,
        })),
    [printers, value],
  );
  return (
    <Select
      showSearch
      size="large"
      loading={loading}
      prefix={<ShopOutlined />}
      placeholder="Chọn nhà in từ danh mục"
      notFoundContent={loading ? "Đang tải…" : "Không có nhà in"}
      filterOption={(input, option) =>
        `${option.label} ${option.code || ""}`
          .toLowerCase()
          .includes(input.trim().toLowerCase())
      }
      options={options}
      value={value || undefined}
      onChange={onChange}
      {...props}
    />
  );
}
